import { type ServiceMethod } from '@/application/interfaces/service';

export type SearchParams = {
  page: number;
};

export type ProductsMapItem = {
  name: string;
  url: string;
  children?: ProductsMapItem[];
};

export type Response = {
  data: ProductsMapItem[];
  page: number;
  perPage: number;
  count: number;
  pages: number;
};

const getProductsMap: ServiceMethod<Response, SearchParams> =
  (httpClient) => async (data) => {
    const { page } = data;

    const { body: response } = await httpClient.get<
      Response,
      undefined,
      SearchParams
    >('/api/v3/sitemap/products', {
      searchParams: {
        page,
      },
    });

    return response;
  };

export default getProductsMap;
